module.exports = __webpack_public_path__ + "static/media/debit.82118f70.jpg";